import "./App.css";

// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ReactGA from "react-ga";

import Home from "./screens/Home";
import Dashboard from "./screens/Dashboard";
import NotFound from "./screens/NotFound";
import AnonymousMessage from "./screens/AnonymousMessage";
import ResultPage from "./screens/Result";
import Confirm from "./screens/Confirm";
import MessageGrid from "./screens/Result";

import ViewMessage from "./screens/viewMessage";

const App = () => {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/confirm"  element={<Confirm />} />
				<Route path="/message" element={<AnonymousMessage />} />
				<Route path="/view" exact element={<ViewMessage />} />
				<Route path="/result" exact element={<ResultPage />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</Router>
	);
};

export default App;
